<template>
	<div>
		<ui-chips
			v-model="emails"
			:error="emailInvalidText"
			:formatter="validateEmail"
			placeholder="Add e-mail..."
			required
		/>
		<ui-dialog-footer>
			<ui-button
				:disabled="isFetching || (lifetime <= 0 && expires === 0)"
				primary
				text="Send e-mail"
				tooltip="Send e-mail with link to added recipients"
				@click="emails.length > 0 && sendEmail()"
			/>
		</ui-dialog-footer>
	</div>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import { isEmail } from "lib/modules/Validate";
import UiButton from "lib/components/ui/Button";
import UiChips from "lib/components/ui/Chips";
import UiDialogFooter from "lib/components/ui/DialogFooter";

export default {
	name: "MediaShareEmail",
	components: {
		UiButton,
		UiChips,
		UiDialogFooter
	},
	props: {
		downloadable: {
			type: Boolean,
			default: false,
			required: false
		},
		expires: {
			type: Number,
			required: true
		},
		lifetime: {
			type: Number,
			required: true
		},
		mediaId: {
			type: String,
			required: true
		},
		password: {
			type: String,
			default: "",
			required: false
		}
	},
	data() {
		return {
			emails: [],
			emailInvalidText: "",
			isFetching: false
		};
	},
	methods: {
		sendEmail() {
			const parameters = {
				key: this.password,
				mailto: this.emails
			};

			if (this.downloadable)
				parameters.downloadable = this.downloadable;

			if (this.expires !== 0)
				parameters.expires = this.expires;

			if (this.lifetime > 0)
				parameters.lifetime = this.lifetime;

			this.isFetching = true;

			http.post(`/api/v2/media/${this.mediaId}/share`, parameters)
			.then(() => {
				this.$emit("send");
			})
			.catch((error) => {
				alert.error("Unable to send email", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		},
		validateEmail(email) {
			if (!isEmail(email) && email) { // && email because function runs one more time after enter press with empty string as function arg
				this.emailInvalidText = "Invalid e-mail address";

				return false;
			}

			this.emailInvalidText = "";

			return email;
		}
	}
};
</script>
